import { render, staticRenderFns } from "./a-heading-rich.vue?vue&type=template&id=77d4131c&"
import script from "./a-heading-rich.vue?vue&type=script&lang=js&"
export * from "./a-heading-rich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports